<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName"
      ><i class="lt"></i><i class="rt"></i>

      <!-- 健康评分管理标签页 -->
      <el-tab-pane name="healthChecking" label="健康评分管理">
        <normalNav :parent="self"> </normalNav>
        <div class="searchForm1">
          <searchForm
            :items="healthCheckingItems"
            :formPlus="form_healthChecking"
            ref="searchForm_healthChecking"
          >
          </searchForm>
        </div>
        <div class="tableWrapper">
          <easyTable
            apiUrl="operation/healthChecking/list"
            :parent="self"
            :config="healthCheckingConfig"
            :other="other"
            ref="table_healthChecking"
          >
            <template slot="last">
              <el-table-column label="操作" width="200" align="center">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="small"
                    @click="viewHealthCheckingDetails(scope.row)"
                    >查看记录</el-button
                  >
                </template>
              </el-table-column>
            </template>
          </easyTable>
        </div>

        <el-dialog
          class="editDialog"
          title="查看健康评分详情"
          :visible.sync="healthCheckingDetailsVisible"
          :close-on-click-modal="false"
          width="80%"
        >
          <div class="health-checking-details-content">
            <div class="searchForm1" style="position: relative;">
              <searchForm
                :items="healthCheckingRecordItems"
                :formPlus="healthCheckingRecordForm"
                ref="searchForm_healthCheckingRecord"
              >
              </searchForm>
              <button
                class="BlueSmBtn"
                @click="searchHealthCheckingRecord"
                style="position: absolute; right: 30px; top: 20px;"
              >
                搜索
              </button>
            </div>
            <div class="tableWrapper">
              <easyTable
                :apiUrl="healthCheckingRecordApiUrl"
                :parent="self"
                :config="healthCheckingRecordConfig"
                :other="healthCheckingRecordOther"
                ref="table_healthCheckingRecord"
              >
              </easyTable>
            </div>
          </div>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { obj2urlsp, descriptor } from "utils";
export default {
  data() {
    return {
      tabName: "healthChecking",
      form_xjrwgl: {},
      editLoading: true,
      editDialogVisible: false,
      detailsVisible: false,
      detailsList: {},
      data: {},
      other: {},
      form1: {},
      isEdit: false,
      rules: {
        healthCheckingType: [
          { required: true, message: "请选择健康评估类型", trigger: "change" }
        ],
        healthIndicatorCode: [
          { required: true, message: "请输入健康指标系统标识", trigger: "blur" }
        ],
        healthIndicatorName: [
          { required: true, message: "请输入健康指标系统名称", trigger: "blur" }
        ],
        healthThreshold: [
          { required: true, message: "请输入健康阈值", trigger: "blur" }
        ],
        subHealthThreshold: [
          { required: true, message: "请输入亚健康阈值", trigger: "blur" }
        ],
        abnormalThreshold: [
          { required: true, message: "请输入异常阈值", trigger: "blur" }
        ],
        defaultScore: [
          { required: false, message: "请输入默认评分", trigger: "blur" }
        ]
      },
      // 阈值配置相关状态
      thresholdDialogVisible: false,
      thresholdStandardId: null,
      thresholdForm: {},
      thresholdOther: {},
      thresholdApiUrl: "",
      thresholdData: {},
      thresholdEditDialogVisible: false,
      thresholdDetailsVisible: false,
      thresholdDetailsList: {},
      thresholdForm1: {},
      isEditThreshold: false,
      thresholdRules: {
        deviceType: [
          { required: true, message: "请输入设备类型", trigger: "blur" }
        ],
        indicatorName: [
          {
            required: true,
            message: "请输入可量化采集指标名称",
            trigger: "blur"
          }
        ],
        indicatorDataFlag: [
          {
            required: true,
            message: "请输入可量化采集指标数据流标识",
            trigger: "blur"
          }
        ],
        scoreWeight: [
          { required: true, message: "请输入评分权重", trigger: "blur" }
        ]
      },
      // 健康评分管理相关状态
      form_healthChecking: {},
      healthCheckingOther: {},
      healthCheckingDialogVisible: false,
      healthCheckingDetailsVisible: false,
      healthCheckingDetailsList: {},
      healthCheckingForm: {},
      isEditHealthChecking: false,
      healthCheckingRules: {
        evaluationYear: [
          { required: true, message: "请输入评定年份", trigger: "blur" }
        ],
        evaluationMonth: [
          { required: true, message: "请输入评定月份", trigger: "blur" }
        ],
        evaluationDay: [
          { required: true, message: "请输入评定日", trigger: "blur" }
        ],
        healthCheckingType: [
          { required: true, message: "请选择健康评估类型", trigger: "change" }
        ]
      },
      // 健康评分记录相关状态
      healthCheckingRecordForm: {},
      healthCheckingRecordOther: {
        deviceName: "",
        indicatorName: ""
      },
      healthCheckingRecordApiUrl: "",
      healthCheckingRecordData: {},
      healthCheckingRecordDetailsVisible: false,
      healthCheckingRecordDetailsList: {}
    };
  },
  watch: {
    editDialogVisible(val) {
      if (!val) {
        this.resetForm();
      }
    },
    // 当阈值配置弹窗关闭时重置表单
    thresholdEditDialogVisible(val) {
      if (!val) {
        this.resetThresholdForm();
      }
    },
    // 健康评分弹窗关闭时重置表单
    healthCheckingDialogVisible(val) {
      if (!val) {
        this.resetHealthCheckingForm();
      }
    }
  },
  computed: {
    items() {
      return [
        {
          type: "input",
          prop: "healthIndicatorCode",
          label: "健康指标系统标识",
          placeholder: "请输入健康指标系统标识"
        },
        {
          type: "input",
          prop: "healthIndicatorName",
          label: "健康指标系统名称",
          placeholder: "请输入健康指标系统名称"
        },
        {
          type: "select",
          prop: "healthCheckingType",
          label: "健康评估类型",
          placeholder: "请选择健康评估类型",
          option: {
            option: [
              { label: "整体", value: 1 },
              { label: "分区", value: 2 },
              { label: "独立监测单元", value: 3 }
            ]
          }
        }
      ];
    },
    // 健康评分管理搜索项
    healthCheckingItems() {
      return [
        {
          type: "input",
          prop: "healthCheckingAreaName",
          label: "健康评估区域名称",
          placeholder: "请输入健康评估区域名称"
        },
        {
          type: "select",
          prop: "healthCheckingType",
          label: "健康评估类型",
          placeholder: "请选择健康评估类型",
          option: {
            option: [
              { label: "整体", value: 1 },
              { label: "分区", value: 2 },
              { label: "独立监测单元", value: 3 }
            ]
          }
        },
        {
          type: "input",
          prop: "evaluationYear",
          label: "评定年份",
          placeholder: "请输入评定年份"
        },
        {
          type: "input",
          prop: "evaluationMonth",
          label: "评定月份",
          placeholder: "请输入评定月份"
        }
      ];
    },
    // 健康评分记录搜索项
    healthCheckingRecordItems() {
      return [
        {
          type: "input",
          prop: "deviceName",
          label: "设备名称",
          placeholder: "请输入设备名称"
        },
        {
          type: "input",
          prop: "indicatorName",
          label: "可量化采集指标名称",
          placeholder: "请输入可量化采集指标名称"
        }
      ];
    },
    self() {
      return this;
    },
    config() {
      return [
        {
          label: "健康评估类型",
          prop: row => {
            return this.displayHealthCheckingType(row.healthCheckingType);
          }
        },
        {
          prop: "healthIndicatorCode",
          label: "健康指标系统标识"
        },
        {
          prop: "healthIndicatorName",
          label: "健康指标系统名称"
        },
        {
          prop: "unitType",
          label: "独立监测单元名称"
        },
        {
          prop: "healthThreshold",
          label: "健康阈值"
        },
        {
          prop: "subHealthThreshold",
          label: "亚健康阈值"
        },
        {
          prop: "abnormalThreshold",
          label: "异常阈值"
        },
        {
          prop: "defaultScore",
          label: "默认评分"
        },
        {
          prop: "evaluationScore",
          label: "评估评分"
        },
        {
          prop: "healthStatus",
          label: "健康状况"
        },
        {
          prop: "remark",
          label: "备注"
        }
      ];
    },
    // 健康评分管理表格列配置
    healthCheckingConfig() {
      return [
        {
          prop: "evaluationYear",
          label: "评定年份"
        },
        {
          prop: "evaluationMonth",
          label: "评定月份"
        },
        {
          prop: "evaluationDay",
          label: "评定日"
        },
        {
          label: "健康评估类型",
          prop: row => {
            return this.displayHealthCheckingType(row.healthCheckingType);
          }
        },
        {
          prop: "healthCheckingAreaId",
          label: "健康评估区域ID"
        },
        {
          prop: "healthCheckingAreaName",
          label: "健康评估区域名称"
        },
        {
          prop: "totalHealthScore",
          label: "总分"
        },
        {
          label: "健康状况",
          prop: row => {
            return row.healthCheckingType == 1
              ? row.fireFightingConclusion
              : row.healthCheckingType == 2
              ? row.zoneRiskLevel
              : row.healthCheckingType == 3
              ? row.unitStatusLevel
              : "未知";
          }
        }
      ];
    },
    // 健康评分记录表格列配置
    healthCheckingRecordConfig() {
      return [
        {
          prop: "deviceName",
          label: "设备名称"
        },
        {
          prop: "indicatorName",
          label: "指标名称"
        },
        {
          prop: "indicatorValue",
          label: "指标值"
        },
        {
          prop: "warningDescription",
          label: "预警描述"
        },
        {
          prop: "warningLevel",
          label: "预警等级",
          formatter: row => {
            return this.displayWarningLevel(row.warningLevel);
          }
        },
        {
          prop: "warningThreshold",
          label: "预警阈值"
        },
        {
          prop: "deductionScore",
          label: "扣分"
        },
        {
          prop: "weight",
          label: "权重"
        },
        {
          prop: "createTime",
          label: "创建时间"
        }
      ];
    }
  },
  methods: {
    reset_xjrwgl(fn) {
      fn();
      this.form_xjrwgl = {};
    },
    search_xjrwgl(fn) {
      fn();
    },
    openAddDialog() {
      this.isEdit = false;
      this.editDialogVisible = true;
      this.form1 = {
        healthCheckingType: null,
        healthIndicatorCode: "",
        healthIndicatorName: "",
        unitType: "",
        healthThreshold: "",
        subHealthThreshold: "",
        abnormalThreshold: "",
        defaultScore: "",
        evaluationScore: "",
        healthStatus: "",
        remark: ""
      };
    },
    editRecord(row) {
      this.isEdit = true;
      this.editDialogVisible = true;
      this.form1 = { ...row };
    },
    viewDetails(row) {
      this.detailsList = { ...row };
      this.detailsVisible = true;
    },
    submitForm() {
      this.$refs["form1"].validate(valid => {
        if (valid) {
          if (this.isEdit) {
            // 更新操作
            this.updateRecord(this.form1);
          } else {
            // 添加操作
            this.addRecord(this.form1);
          }
        }
      });
    },
    addRecord(data) {
      this.$axiospost("operation/healthCheckingStandard/add", data)
        .then(res => {
          if (res.data.status === "10000" || res.data.status === 10000) {
            this.$message.success("添加成功！");
            this.closeDialog();
            this.$refs["table_xjrwgl"].getData();
          } else {
            this.$message.error(
              "添加失败：" + (res.data.message || res.data.msg)
            );
          }
        })
        .catch(err => {
          console.error("添加健康评分标准错误:", err);
          this.$message.error("添加失败，请检查网络或联系管理员");
        });
    },
    updateRecord(data) {
      this.$axiospost("operation/healthCheckingStandard/update", data)
        .then(res => {
          if (res.data.status === "10000" || res.data.status === 10000) {
            this.$message.success("更新成功！");
            this.closeDialog();
            this.$refs["table_xjrwgl"].getData();
          } else {
            this.$message.error(
              "更新失败：" + (res.data.message || res.data.msg)
            );
          }
        })
        .catch(err => {
          console.error("更新健康评分标准错误:", err);
          this.$message.error("更新失败，请检查网络或联系管理员");
        });
    },
    deleteRecord(id) {
      this.$confirm("确认删除这条记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$axiosdelete(`operation/healthCheckingStandard/delete?id=${id}`)
            .then(res => {
              if (res.data.status === "10000" || res.data.status === 10000) {
                this.$message.success("删除成功！");
                this.$refs["table_xjrwgl"].getData();
              } else {
                this.$message.error(
                  "删除失败：" + (res.data.message || res.data.msg)
                );
              }
            })
            .catch(err => {
              console.error("删除健康评分标准错误:", err);
              this.$message.error("删除失败，请检查网络或联系管理员");
            });
        })
        .catch(() => {
          // 用户取消删除
        });
    },
    closeDialog() {
      this.editDialogVisible = false;
      this.resetForm();
    },
    resetForm() {
      if (this.$refs["form1"]) {
        this.$refs["form1"].resetFields();
      }
      this.form1 = {};
    },
    displayHealthCheckingType(type) {
      switch (type) {
        case 1:
          return "整体";
        case 2:
          return "分区";
        case 3:
          return "独立监测单元";
        default:
          return "未知";
      }
    },
    // 打开阈值配置弹窗
    openThresholdConfig(row) {
      this.thresholdStandardId = row.id;
      this.thresholdApiUrl = `operation/healthCheckingTrigger/findByStandardId?standardId=${row.id}`;
      this.thresholdDialogVisible = true;
    },
    // 阈值配置表格数据加载完成后执行
    onThresholdDataLoaded(response) {
      // 如果API返回的数据结构不同，可能需要调整
      if (response && response.data && Array.isArray(response.data)) {
        this.thresholdData = response.data;
      } else if (
        response &&
        response.data &&
        Array.isArray(response.data.rows)
      ) {
        this.thresholdData = response.data.rows;
      }
    },
    // 打开新增阈值配置弹窗
    openAddThresholdDialog() {
      this.isEditThreshold = false;
      this.thresholdEditDialogVisible = true;
      this.thresholdForm1 = {
        id: 0,
        standardId: this.thresholdStandardId,
        deviceType: "",
        deviceTypeId: "",
        indicatorName: "",
        indicatorDataFlag: "",
        indicatorUnit: "",
        indicatorHealthRange: "",
        indicatorSubHealthRange: "",
        indicatorAbnormalRange: "",
        indicatorDefaultValue: "",
        scoreWeight: ""
      };
    },
    // 编辑阈值配置
    editThresholdRecord(row) {
      this.isEditThreshold = true;
      this.thresholdEditDialogVisible = true;
      this.thresholdForm1 = { ...row };
    },
    // 查看阈值配置详情
    viewThresholdDetails(row) {
      this.thresholdDetailsList = { ...row };
      this.thresholdDetailsVisible = true;
    },
    // 提交阈值配置表单
    submitThresholdForm() {
      this.$refs["thresholdFormRef"].validate(valid => {
        if (valid) {
          if (this.isEditThreshold) {
            // 更新操作
            this.updateThresholdRecord(this.thresholdForm1);
          } else {
            // 添加操作
            this.addThresholdRecord(this.thresholdForm1);
          }
        }
      });
    },
    // 添加阈值配置
    addThresholdRecord(data) {
      // 确保标准ID已设置
      data.standardId = this.thresholdStandardId;

      this.$axiospost("operation/healthCheckingTrigger/add", data)
        .then(res => {
          if (res.data.status === "10000" || res.data.status === 10000) {
            this.$message.success("添加阈值配置成功！");
            this.closeThresholdDialog();
            this.$refs["table_threshold"].getData();
          } else {
            this.$message.error(
              "添加阈值配置失败：" + (res.data.message || res.data.msg)
            );
          }
        })
        .catch(err => {
          console.error("添加阈值配置错误:", err);
          this.$message.error("添加阈值配置失败，请检查网络或联系管理员");
        });
    },
    // 更新阈值配置
    updateThresholdRecord(data) {
      this.$axiospost("operation/healthCheckingTrigger/update", data)
        .then(res => {
          if (res.data.status === "10000" || res.data.status === 10000) {
            this.$message.success("更新阈值配置成功！");
            this.closeThresholdDialog();
            this.$refs["table_threshold"].getData();
          } else {
            this.$message.error(
              "更新阈值配置失败：" + (res.data.message || res.data.msg)
            );
          }
        })
        .catch(err => {
          console.error("更新阈值配置错误:", err);
          this.$message.error("更新阈值配置失败，请检查网络或联系管理员");
        });
    },
    // 删除阈值配置
    deleteThresholdRecord(id) {
      this.$confirm("确认删除这条阈值配置记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$axiosdelete(`operation/healthCheckingTrigger/delete?id=${id}`)
            .then(res => {
              if (res.data.status === "10000" || res.data.status === 10000) {
                this.$message.success("删除阈值配置成功！");
                this.$refs["table_threshold"].getData();
              } else {
                this.$message.error(
                  "删除阈值配置失败：" + (res.data.message || res.data.msg)
                );
              }
            })
            .catch(err => {
              console.error("删除阈值配置错误:", err);
              this.$message.error("删除阈值配置失败，请检查网络或联系管理员");
            });
        })
        .catch(() => {
          // 用户取消删除
        });
    },
    // 关闭阈值配置编辑弹窗
    closeThresholdDialog() {
      this.thresholdEditDialogVisible = false;
      this.resetThresholdForm();
    },
    // 重置阈值配置表单
    resetThresholdForm() {
      if (this.$refs["thresholdFormRef"]) {
        this.$refs["thresholdFormRef"].resetFields();
      }
      this.thresholdForm1 = {};
    },

    // 健康评分管理相关方法
    reset_healthChecking(fn) {
      fn();
      this.form_healthChecking = {
        healthCheckingAreaName: "",
        healthCheckingType: "",
        evaluationMouth: "",
        evaluationYear: ""
      };
    },
    search_healthChecking(fn) {
      fn();
    },
    openAddHealthCheckingDialog() {
      this.isEditHealthChecking = false;
      this.healthCheckingDialogVisible = true;
      this.healthCheckingForm = {
        evaluationYear: null,
        evaluationMonth: null,
        evaluationDay: null,
        healthCheckingType: null,
        healthCheckingAreaId: null,
        healthCheckingAreaName: "",
        totalScore: "",
        healthStatus: "",
        remark: ""
      };
    },
    editHealthCheckingRecord(row) {
      this.isEditHealthChecking = true;
      this.healthCheckingDialogVisible = true;
      this.healthCheckingForm = { ...row };
    },
    viewHealthCheckingDetails(row) {
      // 根据行数据的id调用健康评分记录管理的接口获取详细信息
      const id = row.id || row._id || row.healthCheckingId; // 尝试获取ID字段
      if (!id) {
        this.$message.error("无法获取记录ID");
        return;
      }
      // 设置API URL以获取健康评分记录
      this.healthCheckingRecordApiUrl = `operation/healthCheckingRecord/list?healthCheckingId=${id}`;

      // 初始化其他参数
      this.healthCheckingRecordOther = {
        deviceName: "",
        indicatorName: ""
      };
      this.healthCheckingDetailsVisible = true;
    },
    submitHealthCheckingForm() {
      this.$refs["healthCheckingForm"].validate(valid => {
        if (valid) {
          if (this.isEditHealthChecking) {
            // 更新操作
            this.updateHealthCheckingRecord(this.healthCheckingForm);
          } else {
            // 添加操作
            this.addHealthCheckingRecord(this.healthCheckingForm);
          }
        }
      });
    },
    searchHealthCheckingRecord() {
      // 直接从searchForm组件实例获取当前表单数据
      const searchFormInstance = this.$refs.searchForm_healthCheckingRecord;

      // 确保表单实例存在并获取最新的表单数据
      if (searchFormInstance && searchFormInstance.form) {
        // 将searchForm中的实际数据赋值给healthCheckingRecordOther
        Object.assign(this.healthCheckingRecordOther, {
          ...searchFormInstance.form
        });

        // 输出调试信息
        console.log("搜索参数:", searchFormInstance.form);
        console.log("更新后的other值:", this.healthCheckingRecordOther);

        // 刷新表格数据
        if (this.$refs.table_healthCheckingRecord) {
          // 确保表格组件的other属性也更新
          Object.assign(this.$refs.table_healthCheckingRecord.other, {
            ...searchFormInstance.form
          });
          console.log(
            "调用getData前的other值:",
            this.$refs.table_healthCheckingRecord.other
          );
          this.$refs.table_healthCheckingRecord.getData(1);
        }
      } else {
        console.error("searchForm实例不存在");
      }
    },
    addHealthCheckingRecord(data) {
      this.$axiospost("operation/healthChecking/add", data)
        .then(res => {
          if (res.data.status === "10000" || res.data.status === 10000) {
            this.$message.success("添加成功！");
            this.closeHealthCheckingDialog();
            this.$refs["table_healthChecking"].getData();
          } else {
            this.$message.error(
              "添加失败：" + (res.data.message || res.data.msg)
            );
          }
        })
        .catch(err => {
          console.error("添加健康评分错误:", err);
          this.$message.error("添加失败，请检查网络或联系管理员");
        });
    },
    updateHealthCheckingRecord(data) {
      this.$axiospost("operation/healthChecking/update", data)
        .then(res => {
          if (res.data.status === "10000" || res.data.status === 10000) {
            this.$message.success("更新成功！");
            this.closeHealthCheckingDialog();
            this.$refs["table_healthChecking"].getData();
          } else {
            this.$message.error(
              "更新失败：" + (res.data.message || res.data.msg)
            );
          }
        })
        .catch(err => {
          console.error("更新健康评分错误:", err);
          this.$message.error("更新失败，请检查网络或联系管理员");
        });
    },
    deleteHealthCheckingRecord(id) {
      this.$confirm("确认删除这条健康评分记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$axiosdelete(`operation/healthChecking/delete?id=${id}`)
            .then(res => {
              if (res.data.status === "10000" || res.data.status === 10000) {
                this.$message.success("删除成功！");
                this.$refs["table_healthChecking"].getData();
              } else {
                this.$message.error(
                  "删除失败：" + (res.data.message || res.data.msg)
                );
              }
            })
            .catch(err => {
              console.error("删除健康评分错误:", err);
              this.$message.error("删除失败，请检查网络或联系管理员");
            });
        })
        .catch(() => {
          // 用户取消删除
        });
    },
    closeHealthCheckingDialog() {
      this.healthCheckingDialogVisible = false;
      this.resetHealthCheckingForm();
    },
    resetHealthCheckingForm() {
      if (this.$refs["healthCheckingForm"]) {
        this.$refs["healthCheckingForm"].resetFields();
      }
      this.healthCheckingForm = {};
    },

    // 健康评分记录相关方法
    // 移除了addHealthCheckingRecord方法

    // 查看健康评分记录详情
    viewHealthCheckingRecordDetails(row) {
      this.healthCheckingRecordDetailsList = { ...row };
      this.healthCheckingRecordDetailsVisible = true;
    },

    // 显示预警等级
    displayWarningLevel(level) {
      switch (level) {
        case 1:
          return "一般预警";
        case 2:
          return "严重预警";
        default:
          return "未知";
      }
    }
  },
  components: {
    normalNav: () => import("public/normalNav"),
    searchForm: () => import("public/searchForm"),
    easyTable: () => import("public/easyTable"),
    nextCompany: () => import("public/nextCompany")
  },
  mounted() {
    // 组件挂载时可能需要初始化数据，目前保持原有逻辑
  }
};
</script>

<style lang="less" scoped>
.point {
  span {
    padding-left: 5px;
    color: #fff;
    font-size: 14px;
    display: inline-block;
    height: 14px;
    line-height: 14px;
    border-left: 2px solid #35b9f7;
  }

  border-bottom: 1px solid #777;
  line-height: 36px;
  margin-top: 15px;
  margin-bottom: 15px;
}
/deep/ .editDialog .el-form-item__label {
  text-align: right !important;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
  margin-left: 10px;
  font-size: 10px;
}
.el-form-item__content {
  img {
    max-width: 400px;
    max-height: 400px;
  }
}

.threshold-config-content {
  .threshold-actions {
    margin-top: 20px;
    text-align: center;
    button {
      width: 100px;
    }
  }
}
// 修复searchForm标签文字拥挤问题
.threshold-config-content /deep/ .el-form-item__label {
  white-space: nowrap;
}
.threshold-config-content /deep/ .el-form-item {
  width: 30%;
}

// 修复searchForm标签文字拥挤问题
.searchForm1 /deep/ .el-form-item__label {
  white-space: nowrap;
}
.searchForm1 /deep/ .el-form-item {
  width: 30%;
}

.health-checking-details-content {
  /* 移除了新增记录按钮相关的样式 */
}

// 修复searchForm标签文字拥挤问题
.health-checking-details-content /deep/ .el-form-item__label {
  white-space: nowrap;
}
.health-checking-details-content /deep/ .el-form-item {
  width: 30%;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/standardEvaluation/scoreManagement/index.vue